import { ArrowUp, ArrowDown } from "@phosphor-icons/react";
import { Badge } from "../ui/badge";
import { getTextPrimary, getTextSecondary, getDividerClass, getHoverRowClass, getCardClass, getBorderClass } from "../../lib/styleHelpers";

export function PerformanceTable({ comparisons, isDark }) {
  return (
    <div className={`rounded-xl border ${getCardClass(isDark)}`} data-testid="perf-table">
      <div className={`p-4 border-b ${getBorderClass(isDark)}`}>
        <h3 className={`font-bold ${getTextPrimary(isDark)}`}>Detailed Comparison</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className={isDark ? "bg-[#0c0c16]" : "bg-gray-50"}>
              <th className={`px-4 py-3 text-left font-medium ${getTextSecondary(isDark)}`}>Opportunity</th>
              <th className={`px-4 py-3 text-right font-medium ${getTextSecondary(isDark)}`}>Predicted</th>
              <th className={`px-4 py-3 text-right font-medium ${getTextSecondary(isDark)}`}>Actual</th>
              <th className={`px-4 py-3 text-right font-medium ${getTextSecondary(isDark)}`}>Deviation</th>
              <th className={`px-4 py-3 text-right font-medium ${getTextSecondary(isDark)}`}>P&L</th>
              <th className={`px-4 py-3 text-center font-medium ${getTextSecondary(isDark)}`}>Accuracy</th>
            </tr>
          </thead>
          <tbody className={`divide-y ${getDividerClass(isDark)}`}>
            {comparisons.map((c) => (
              <tr key={`${c.title}-${c.entry_date}`} className={getHoverRowClass(isDark)}>
                <td className={`px-4 py-3 ${getTextPrimary(isDark)}`}>
                  <div className="max-w-[200px] truncate font-medium">{c.title}</div>
                  <div className={`text-xs ${isDark ? "text-gray-600" : "text-gray-400"}`}>{c.entry_date}</div>
                </td>
                <td className={`px-4 py-3 text-right ${isDark ? "text-gray-300" : "text-gray-700"}`}>{c.predicted_roi.toFixed(1)}%</td>
                <td className={`px-4 py-3 text-right font-bold ${c.actual_roi >= 0 ? "text-emerald-500" : "text-red-500"}`}>
                  <span className="flex items-center justify-end gap-1">
                    {c.actual_roi >= 0 ? <ArrowUp size={12} /> : <ArrowDown size={12} />}
                    {c.actual_roi.toFixed(1)}%
                  </span>
                </td>
                <td className={`px-4 py-3 text-right ${Math.abs(c.deviation) <= 10 ? "text-emerald-500" : "text-amber-500"}`}>
                  {c.deviation >= 0 ? "+" : ""}{c.deviation.toFixed(1)}%
                </td>
                <td className={`px-4 py-3 text-right font-bold ${c.pnl >= 0 ? "text-emerald-500" : "text-red-500"}`}>
                  ${Math.abs(c.pnl).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </td>
                <td className="px-4 py-3 text-center">
                  <Badge className={c.accurate
                    ? "text-emerald-400 bg-emerald-500/10 border-emerald-500/30"
                    : "text-amber-400 bg-amber-500/10 border-amber-500/30"
                  }>
                    {c.accurate ? "Accurate" : "Off"}
                  </Badge>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
